module.exports = __webpack_public_path__ + "static/media/YF02_1.407e1516.jpg";